<template>
  <div class="matchResult">
    <div class="table">
      <a-table :columns="columns" :pagination="false" :data-source="data"></a-table>
    </div>

    <div class="time-details">
      <div class="match-stats" v-if="footballSituationData.redCards">
        <!-- 上排数据 -->
        <div class="stats-row">
          <!-- 第1列：主队角球 -->
          <div class="stat-item">
            <img src="@assets/icons/score/corner.webp" alt="角球" class="card-icon marginT-10px" />
          </div>
          <!-- 第2列：主队红牌 -->
          <div class="stat-item">
            <img src="@assets/icons/score/red_card.webp" alt="红牌" class="card-icon marginT-10px" />
          </div>
          <!-- 第3列：主队黄牌 -->
          <div class="stat-item">
            <img src="@assets/icons/score/yellow_card.webp" alt="黄牌" class="card-icon marginT-10px" />
          </div>
          <!-- 第4列：射门数据 -->
          <div class="stat-item progress-column">
            <span class="stat-number">{{ footballSituationData.goalKicks?.team1 || 0 }}</span>
            <span class="stat-label">射门</span>
            <span class="stat-number">{{ footballSituationData.goalKicks?.team2 || 0 }}</span>
          </div>
          <!-- 第5列：客队黄牌 -->
          <div class="stat-item">
            <img src="@assets/icons/score/yellow_card.webp" alt="黄牌" class="card-icon marginT-10px" />
          </div>
          <!-- 第6列：客队红牌 -->
          <div class="stat-item">
            <img src="@assets/icons/score/red_card.webp" alt="红牌" class="card-icon marginT-10px" />
          </div>
          <!-- 第7列：客队角球 -->
          <div class="stat-item">
            <img src="@assets/icons/score/corner.webp" alt="角球" class="card-icon marginT-10px" />
          </div>
        </div>

        <!-- 进度条行 -->
        <div class="progress-row">
          <div class="empty-column"></div>
          <div class="empty-column"></div>
          <div class="empty-column"></div>
          <!-- 射门进度条 -->
          <div class="progress-column">
            <div class="progress-bar">
              <div
                class="progress-fill team1"
                :style="{ width: getProgressWidth(footballSituationData.goalKicks?.team1 || 0, footballSituationData.goalKicks?.team2 || 0, 'team1') }"
              ></div>
              <div
                class="progress-fill team2"
                :style="{ width: getProgressWidth(footballSituationData.goalKicks?.team1 || 0, footballSituationData.goalKicks?.team2 || 0, 'team2') }"
              ></div>
            </div>
          </div>
          <div class="empty-column"></div>
          <div class="empty-column"></div>
          <div class="empty-column"></div>
        </div>

        <!-- 下排数据 -->
        <div class="stats-row">
          <!-- 第1列：主队角球（空） -->
          <div class="stat-item">
            <span class="stat-number">{{ footballSituationData.cornerKicks?.team1 || 0 }}</span>
          </div>
          <!-- 第2列：主队红牌（空） -->
          <div class="stat-item">
            <span class="stat-number">{{ footballSituationData.redCards.team1 || 0 }}</span>
          </div>
          <!-- 第3列：主队黄牌（空） -->
          <div class="stat-item">
            <span class="stat-number">{{ footballSituationData.yellowCards.team1 || 0 }}</span>
          </div>
          <!-- 第4列：射正数据 -->
          <div class="stat-item progress-column">
            <span class="stat-number">{{ footballSituationData.shootOnGoal?.team1 || 0 }}</span>
            <span class="stat-label">射正</span>
            <span class="stat-number">{{ footballSituationData.shootOnGoal?.team2 || 0 }}</span>
          </div>
          <!-- 第5列：客队黄牌（空） -->
          <div class="stat-item">
            <span class="stat-number">{{ footballSituationData.yellowCards.team2 || 0 }}</span>
          </div>
          <!-- 第6列：客队红牌（空） -->
          <div class="stat-item">
            <span class="stat-number">{{ footballSituationData.redCards.team2 || 0 }}</span>
          </div>
          <!-- 第7列：客队角球（空） -->
          <div class="stat-item">
            <span class="stat-number">{{ footballSituationData.cornerKicks?.team2 || 0 }}</span>
          </div>
        </div>

        <!-- 射正进度条行 -->
        <div class="progress-row">
          <div class="empty-column"></div>
          <div class="empty-column"></div>
          <div class="empty-column"></div>
          <!-- 射正进度条 -->
          <div class="progress-column">
            <div class="progress-bar">
              <div
                class="progress-fill team1"
                :style="{ width: getProgressWidth(footballSituationData.shootOnGoal?.team1 || 0, footballSituationData.shootOnGoal?.team2 || 0, 'team1') }"
              ></div>
              <div
                class="progress-fill team2"
                :style="{ width: getProgressWidth(footballSituationData.shootOnGoal?.team1 || 0, footballSituationData.shootOnGoal?.team2 || 0, 'team2') }"
              ></div>
            </div>
          </div>
          <div class="empty-column"></div>
          <div class="empty-column"></div>
          <div class="empty-column"></div>
        </div>
      </div>
    </div>

    <div class="tab-container">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab"
        :class="{ active: activeTab === index }"
        @click="setActiveTab(index)"
      >
        {{ tab }}
        <div v-if="activeTab === index" class="underline"></div>
      </div>
    </div>
    <div class="chat" v-if="tabs.length">
      <div v-if="activeTab === 0">
        <critical-event
          :data="eventBall.firstHalf"
          title="上半场"
          v-if="eventBall.firstHalf.length"
        />
        <div style="margin-top: 20px"></div>
        <critical-event
          :data="eventBall.secondHalf"
          title="下半场"
          v-if="eventBall.secondHalf.length"
        />
        <div class="empty" v-if="!eventBall.firstHalf.length && !eventBall.secondHalf.length">
          <img src="@assets/icons/score/empty.webp" alt="Empty" class="empty-image" />
          <p>暂无数据</p>
        </div>
      </div>

      <div v-else class="statistics">
        <p class="title">比赛信息</p>
        <div class="border_event" style="margin-top: 9px; margin-bottom: 16px"></div>
        <div class="referee">
          <div class="referee-name flex mt-10">
            <span class="name">当值主裁</span>
            <span class="key">--</span>
          </div>
          <div class="penaltyCard mt-10">
            <p class="name">场均罚牌</p>
            <div>
              <p>
                <img src="@assets/icons/score/red_card.webp" alt="" />
                <span class="key">{{
                  footballSituationData.redCards.team1 + footballSituationData.redCards.team2
                }}</span>
              </p>
              <p>
                <img src="@assets/icons/score/yellow_card.webp" alt="" />
                <span class="key">{{
                  footballSituationData.yellowCards.team1 + footballSituationData.yellowCards.team2
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="border_event" style="margin: 16px 0"></div>
        <div class="info">
          <p class="flex mt-10">
            <span class="name">比赛场馆</span>
            <span class="key">{{ scoreItemData.title }}</span>
          </p>
          <p class="flex mt-10">
            <span class="name">比赛地点</span>
            <span class="key">--</span>
          </p>
          <p class="flex mt-10">
            <span class="name">现场观众人数</span>
            <span class="key">{{ scoreItemData.fans }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { mockData_event } from '@/views/live-detail/footballComponents/eventLegendStatus'
import LineupList from '@/views/scoreFootball/components/lineupList.vue'
import { onMounted, reactive, ref, watch } from 'vue'
import { getFootballSituationsAPI, getMatchFootballEventAPI } from '@/api/match'

import { scoreRightStore } from '@/stores/useScoreRight'
import { storeToRefs } from 'pinia'
import CriticalEvent from '@/views/scoreFootball/components/criticalEvent.vue'

const useScoreRightStore = scoreRightStore()
const { scoreItemData } = storeToRefs(useScoreRightStore)

const columns = [
  {
    title: '比赛对阵',
    dataIndex: 'name',
    key: 'name',
    width: 100
  },
  {
    title: '上',
    dataIndex: 'top',
    key: 'top',
    ellipsis: true
  },
  {
    title: '下',
    dataIndex: 'down',
    key: 'down',
    ellipsis: true
  },
  {
    title: '全场',
    dataIndex: 'allThose',
    key: 'allThose',
    ellipsis: true,
    width: 80,
    render: () => {
      return {
        style: { color: 'red' }
      }
    }
  }
]

const data: any = ref([])

const activeTab = ref(0)
const tabs: any = ref(['关键事件', '技术统计'])

const setActiveTab = (index: number) => {
  activeTab.value = index
}

const activeKey = ref(['1'])
const expandIconPosition = ref('right')

const eventBall: any = reactive({
  firstHalf: [], // 上半场
  secondHalf: [] // 下半场
})

const noneInfo = ref(false)

const getKeyEvents = (matchId: number) => {
  // let matchId = route.query.id

  getMatchFootballEventAPI({ matchId: matchId.toString() }).then((res) => {
    // eventId 0:暂无比赛消息  1：比赛开始  13：中场休息  3：比赛结束
    let data = res.data

    // console.log(res.data, '-res.data-');

    // let data = mockData_event
    if (data.length === 1 && data[0].eventId === 0) return (noneInfo.value = true)
    let dataEvent = data.filter((item: any) => ![1, 0, 3].includes(item.eventId))
    let halftimeIndex = dataEvent.findIndex((item: any) => item.eventId === 13)
    if (halftimeIndex === -1) {
      eventBall.firstHalf = [...dataEvent]
    } else {
      eventBall.secondHalf = [...dataEvent.slice(0, halftimeIndex - 1)]
      eventBall.firstHalf = [...dataEvent.slice(halftimeIndex + 1)]
    }
  })
}

const footballSituationData: any = ref({})
const getFootballSituations = (matchId: number) => {
  getFootballSituationsAPI({ matchId: matchId.toString() }).then((res) => {
    footballSituationData.value = res.data
  })
}

watch(
  () => scoreItemData.value,
  (newVal) => {
    if (newVal) {
      setTableData(newVal)
    }
  },
  { deep: true }
)

// 计算进度条宽度
const getProgressWidth = (team1Value: number, team2Value: number, team: 'team1' | 'team2') => {
  const total = team1Value + team2Value
  if (total === 0) return '50%'

  if (team === 'team1') {
    return `${(team1Value / total) * 100}%`
  } else {
    return `${(team2Value / total) * 100}%`
  }
}

const setTableData = (val: any) => {
  // 添加安全检查，确保数据存在
  if (!val) {
    console.warn('setTableData: val is undefined or null')
    return
  }

  const halfScore = val.half_score || [0, 0]
  const fullScore = val.full_score || [0, 0]

  data.value = [
    {
      name: val.home_team_name || '主队',
      top: halfScore[0] || 0,
      allThose: fullScore[0] || 0,
      down: (fullScore[0] || 0) - (halfScore[0] || 0)
    },
    {
      name: val.away_team_name || '客队',
      top: halfScore[1] || 0,
      allThose: fullScore[1] || 0,
      down: (fullScore[1] || 0) - (halfScore[1] || 0)
    }
  ]

  if (val.id) {
    getKeyEvents(val.id)
    getFootballSituations(val.id)
  }
}

onMounted(() => {
  if (scoreItemData.value) {
    setTableData(scoreItemData.value)
  }
})
</script>

<style scoped lang="scss">
.matchResult {
  padding: 20px 16px;

  // 隐藏滚动条
  ::-webkit-scrollbar {
    display: none;
  }

  .table {
    :deep(.ant-table-thead th) {
      background-color: $bg-stripe;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: $text-secondary;
      padding: 8px 8px;
    }

    :deep(.ant-table-tbody td) {
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: $text-primary;
      background-color: $bg-white;
      padding: 8px 8px;
    }

    :deep(.ant-table-tbody td:first-child) {
      color: $text-dark;
      font-weight: 500;
    }

    :deep(.ant-table-tbody td:last-child) {
      color: $text-dark;
      font-weight: 600;
    }
  }

  .tab-container {
    display: flex;
    justify-content: space-around;
    padding: 10px 0;
    background-color: #fff;
    border-top: 1px solid $border-color;
  }

  .tab {
    position: relative;
    padding: 5px 20px;
    font-size: 14px;
    cursor: pointer;
    color: $text-secondary;
    text-align: center;
  }

  .tab.active {
    color: $color-primary;
    font-weight: bold;
  }

  .underline {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 2px;
    background-color: $color-primary;
    border-radius: 1px;
  }

  .statistics {
    padding: 10px 20px;
    height: 300px;
    background: $bg-white;
    border-radius: 8px 8px 8px 8px;

    .border_event {
      height: 1px;
      background: $border-color;
      border-radius: 0px 0px 0px 0px;
    }

    .name {
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: $text-secondary;
    }

    .key {
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: $text-dark;
    }

    .flex {
      display: flex;
      justify-content: space-between;
    }

    .mt-10 {
      margin-top: 10px;
    }

    .title {
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: $text-dark;
    }

    .referee {
      .referee-name {
      }
    }

    .penaltyCard {
      display: flex;
      justify-content: space-between;

      div {
        display: flex;

        p {
          display: flex;
          align-items: center;
          margin-right: 16px;

          img {
            width: 14px;
            height: 14px;
            margin-right: 6px;
          }
        }
      }

      p {
        display: flex;
      }
    }
  }

  .time-details {
    margin: 16px 0;

    .match-stats {
      background: #fff;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid $border-color;

      .stats-row, .progress-row {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 2fr 1fr 1fr 1fr;
        gap: 8px;
        align-items: center;
        margin-bottom: 4px;

        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2px;

          .card-icon {
            width: 14px;
            height: 14px;
          }
          .marginT-10px{
            margin-top: 20px;
          }

          .stat-number {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: $text-dark;
          }

          .stat-label {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 10px;
            color: $text-secondary;
          }

          &.progress-column {
            flex-direction: row;
            justify-content: space-between;
            gap: 4px;

            .stat-number {
              font-size: 12px;
            }

            .stat-label {
              font-size: 10px;
            }

            .stat-number:first-of-type {
              color: $color-secondary;
            }

            .stat-number:last-of-type {
              color: $color-warning;
            }
          }
        }

        .empty-column {
          height: 1px;
        }

        .progress-column {
          .progress-bar {
            height: 3px;
            background-color: #f0f0f0;
            border-radius: 2px;
            overflow: hidden;
            display: flex;
            margin: 2px 0;

            .progress-fill {
              height: 100%;
              transition: width 0.3s ease;

              &.team1 {
                background-color: #1890ff;
              }

              &.team2 {
                background-color: #ff4d4f;
              }
            }
          }
        }
      }
    }
  }
}
</style>
